import React, { createContext, useState, useContext } from 'react';
import DetailModal from '../components/DetailModal';

const DetailModalContext = createContext();

export const DetailModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [modalData, setModalData] = useState(null);

  const openDetailModal = (type, data) => {
    setModalType(type);
    setModalData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <DetailModalContext.Provider value={{ openDetailModal, closeModal }}>
      {children}
      <DetailModal 
        open={isModalOpen} 
        handleClose={closeModal} 
        data={modalData}
      />
    </DetailModalContext.Provider>
  );
};

export const useDetailModal = () => useContext(DetailModalContext);